import { Route } from 'react-router-dom';
import PageTitle from '../components/PageTitle';
import ItemPage from '../pages/Catalog/items/ItemPage';
import ItemUnits from '../pages/Catalog/units/ItemUnits';
import ItemCategories from '../pages/Catalog/categories/ItemCategories';
import ItemSizesPage from '../pages/Catalog/sizes/ItemSizesPage';
import ProtectedRouteV2 from './ProtectedRouteV2';
import ItemColorsPage from '../pages/Catalog/colors/ItemColorsPage';
import ProductSubCategoryPage from '../pages/Catalog/subCategories/ProductSubCategoryPage';
import BrandPage from '../pages/Catalog/brands/BrandPage';

const catalogRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    <Route
      path="/catalog/items"
      element={
        <>
          <PageTitle title="Catálogo de Ítems | POS System" />
          <ItemPage />
        </>
      }
    />

    <Route
      path="/catalog/items/page/:page"
      element={
        <>
          <PageTitle title="Catálogo de Ítems | POS System" />
          <ItemPage />
        </>
      }
    />

    <Route
      path="/catalog/categories"
      element={
        <>
          <PageTitle title="Categorías de Ítems | POS System" />
          <ItemCategories />
        </>
      }
    />

    <Route
      path="/catalog/sub-categories"
      element={
        <>
          <PageTitle title="Subcategorías | POS System" />
          <ProductSubCategoryPage />
        </>
      }
    />

    <Route
      path="/catalog/brands"
      element={
        <>
          <PageTitle title="Marcas | POS System" />
          <BrandPage />
        </>
      }
    />

    <Route
      path="/catalog/units"
      element={
        <>
          <PageTitle title="Unidades de Medida | POS System" />
          <ItemUnits />
        </>
      }
    />

    <Route
      path="/catalog/sizes"
      element={
        <>
          <PageTitle title="Tallas | POS System" />
          <ItemSizesPage />
        </>
      }
    />

    <Route
      path="/catalog/colors"
      element={
        <>
          <PageTitle title="Colores | POS System" />
          <ItemColorsPage />
        </>
      }
    />
  </Route>
);

export default catalogRoutes;
